// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"15":"9fb83d1b","93":"52c36d0f","312":"76403a12","573":"ab8c11a5","859":"b54d91ef","897":"ea8b309c"}[chunkId] + ".css";
};